import { Beca, IBeca } from '@/shared/model/seguimiento/beca.model';
import { TipoReceptor } from '@/shared/model/enumerations/tipo-receptor';

export interface IReceptor {
  nombre?: string | null;
  apellidoPaterno?: string | null;
  apellidoMaterno?: string | null;
  cvu?: string | null;
  curp?: string | null;
  rfc?: string | null;
  clabe?: string | null;
  beca?: Beca | null;
  tipoReceptor?: TipoReceptor | null;
  moneda?: string | null;
}

export class Receptor implements IReceptor {
  constructor(
    public nombre?: string | null,
    public apellidoPaterno?: string | null,
    public apellidoMaterno?: string | null,
    public cvu?: string | null,
    public curp?: string | null,
    public rfc?: string | null,
    public clabe?: string | null,
    public beca?: Beca | null,
    public tipoReceptor?: TipoReceptor | null,
    public moneda?: string | null
  ) {}

  static fromObject(data: IReceptor): Receptor {
    const transformations = {
      beca: (beca: IBeca) => Beca.fromObject(beca),
    };

    const receptor = new Receptor();
    for (const [key, value] of Object.entries(data)) {
      const transform = transformations[key as keyof IReceptor];
      receptor[key] = transform ? transform(value) : value;
    }

    return receptor;
  }
}
